import React from 'react'

const CartContext = React.createContext({
  cartList: [],
  wishList: [],
  removeAllCartItems: () => {},
  addCartItem: () => {},
  removeCartItem: () => {},
  incrementCartItemQuantity: () => {},
  decrementCartItemQuantity: () => {},
  addWishList: () => {},
})

export default CartContext
